import React from "react";
import { Grid, TextField, TextFieldProps } from "@mui/material";

type CustomInputProps = TextFieldProps & {
  label: string;
  xs?: number;
  errorText?: string;
  inputTextColor?: string;
  labelColor?: string;
};

const CustomInput: React.FC<CustomInputProps> = ({
  label,
  xs = 12,
  errorText,
  inputTextColor = "#fff", // ⬅️ Default: white
  labelColor = "#fff",     // ⬅️ Default: white
  sx = {},
  ...props
}) => {
  return (
    <Grid item xs={xs}>
      <TextField
        fullWidth
        variant="standard"
        label={label}
        error={!!errorText}
        helperText={errorText}
        InputLabelProps={{
          style: {
            color: labelColor,
            marginBottom: 8,
            fontSize: undefined, // fallback for non-MUI v5
          },
          sx: {
            fontSize: { xs: '16px', md: '18px' },
          }
        }}
        InputProps={{
          disableUnderline: false,
          sx: {
            color: inputTextColor,
            fontSize: "2rem",
            marginTop: { xs: "4px", md: "5px" },
            "&:before": {
              borderBottom: "1px solid #a5a5a5",
            },
            "&:hover:not(.Mui-disabled):before": {
              borderBottom: "1px solid #888",
            },
            "&:after": {
              borderBottom: "2px solid #000",
            },
            ...sx, // Allow external overrides of styles safely
          },
        }}
        {...props}
      />
    </Grid>
  );
};

export default CustomInput;
